// extracted by mini-css-extract-plugin
export default {"tryAgain":"bx_cC","result":"bx_cD"};